import fetch from 'isomorphic-fetch';
import { actions as tableActions } from '../modules/DataTable';

export const GRID_DATA_TABLE_URL_SET = 'GRID_DATA_TABLE_SET_URL';
export const GRID_DATA_TABLE_FETCH_FAILURE = 'GRID_DATA_TABLE_FETCH_FAILURE';

/**
 * Change fetch URL
 * @param {String} stateKey Table state key
 * @param {String} url New fetch URL
 * @returns {{}} Action
 */
export function setUrl(stateKey, url) {
    return {
        type: GRID_DATA_TABLE_URL_SET,
        stateKey,
        url,
    };
}

function fetchDataFailure() {
    return {
        type: GRID_DATA_TABLE_FETCH_FAILURE,
    };
}

/**
 * Fetch data from external source
 * @param {String} stateKey
 * @param {String} url
 * @param {Function|Array} [afterActions]
 * @returns {function(*)}
 */
export function fetchData(stateKey, url, afterActions) {
    return (dispatch) => {
        if (!url) {
            return null;
        }

        dispatch(tableActions.setLoading(stateKey, true));
        dispatch(setUrl(stateKey, url));

        return fetch(url, { credentials: 'include' })
            .then(response => response.json())
            .then((data) => {
                dispatch(tableActions.importData(stateKey, data, afterActions));
                return data;
            })
            .catch((err) => {
                dispatch(tableActions.clearData(stateKey));
                dispatch(fetchDataFailure());
                return Promise.reject(err);
            });
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/gridDataTable.js